import { render, staticRenderFns } from "./project-industry-list.vue?vue&type=template&id=a5fe532e&"
import script from "./project-industry-list.vue?vue&type=script&lang=js&"
export * from "./project-industry-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports